import React from 'react';
import { Chip } from 'radiance-ui';
import { v4 as uuid } from 'uuid';
import { TaggedLink } from './TaggedLink';
import { EVENTS } from 'consts/metricsTrackingEvents';
import { trackEvent } from 'utils/metricsTracking';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';

import * as Style from './TaggedLinks.style';
import type { TaggedLinkType } from '../../../content';

export interface TaggedLinksPropsType {
  links: TaggedLinkType[];
  isEcommerceNavigation: boolean;
  isOpen: boolean;
  setIsModalOpen?: (value: boolean) => void;
  isMobile?: boolean;
}

export const TaggedLinks = ({
  links,
  isEcommerceNavigation,
  isOpen,
  setIsModalOpen,
  isMobile = false,
}: TaggedLinksPropsType) => {
  const handleEcommerceClick =
    (product: string, href: string) => (event: React.SyntheticEvent) => {
      event.preventDefault();
      trackEvent(EVENTS.linkClicked, {
        path: window.location.pathname,
        type: 'PDP',
        name: product,
      });
      setIsModalOpen?.(false);
      navExternalWithQueryString(href);
    };

  const linkStyles = isMobile
    ? Style.mobileLinkStyles
    : Style.desktopLinkStyles;

  const renderTags = (tags: string[]) => (
    <Style.ChipContainer>
      {tags.map((tag, index) => (
        <Chip text={tag} key={index} status={'info'} />
      ))}
    </Style.ChipContainer>
  );

  return (
    <React.Fragment>
      {links.map(({ label, htmlLabel, href, tags }) => (
        <Style.NestedLinkContainer key={uuid()}>
          <TaggedLink
            label={label}
            htmlLabel={htmlLabel}
            href={href}
            isEcommerceNavigation={isEcommerceNavigation}
            isOpen={isOpen}
            linkStyles={linkStyles}
            setIsModalOpen={setIsModalOpen}
            handleEcommerceClick={handleEcommerceClick}
          />
          {tags && renderTags(tags)}
        </Style.NestedLinkContainer>
      ))}
    </React.Fragment>
  );
};
